import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=e3a594be"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a594be')) {
      api.createRecord('e3a594be', component.options)
    } else {
      api.reload('e3a594be', component.options)
    }
    module.hot.accept("./Conversation.vue?vue&type=template&id=e3a594be", function () {
      api.rerender('e3a594be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/Conversation.vue"
export default component.exports